var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { fetcher } from "@/api/schema";
export function getAllGroups() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get("/api/groups");
        return data;
    });
}
export const deleteGroup = fetcher.path("/api/groups/{group_id}").method("delete").create();
export const purgeGroup = fetcher.path("/api/groups/{group_id}/purge").method("post").create();
export const undeleteGroup = fetcher.path("/api/groups/{group_id}/undelete").method("post").create();
